import memoize from 'memoize-one';

export default memoize(() => [
  {
    name: 'Fecha/Hora Inicio',
    selector: 'parsed_start_date',
    sortable: true,
    grow: '1',
    center: true
  },
  {
    name: 'Fecha/Hora Termino',
    selector: 'parsed_end_date',
    sortable: true,
    grow: '1',
    center: true
  },
  {
    name: 'Incidencia',
    selector: 'incident',
    sortable: true,
    grow: '1',
    align: 'left'
  },
  {
    name: 'Fecha Creacion',
    selector: 'parsed_created_at',
    sortable: true,
    grow: '1',
    center: true
  }
]);
